import type { APIOrganizationDataGrant } from '@visorpro/client'
import type { MRT_Cell } from 'material-react-table'
import { observer } from 'mobx-react-lite'
import { useOrganization } from '../../../../stores/organization-store'
import type { Stores } from '../../../../util/store'

export interface OrganizationCellOptions {
    cell: MRT_Cell<APIOrganizationDataGrant, any>
    stores: Stores
}

export const OrganizationCell = observer<OrganizationCellOptions>(
    ({ cell, stores }) => {
        const organizationId = cell.getValue<string>()
        const organization = useOrganization(
            stores.organizations,
            organizationId,
        )
        return <div>{organization?.name}</div>
    },
)
